export { SpaTreatmentsCategoryV2Connected as SpaTreatmentsCategoryV2 } from './container';
